<template lang="pug">
  #app(:class="{'loading-axios': loadingAxios}")
    template(v-if="!this.$route.path.includes('login')")
      header-content
      div.flex-container
        nav-content
        ods-main
          ods-scrollbar(:wrapClass="wrapClass")
            router-view(ref="routeView")
            footer
    template(v-else)
      router-view

    ods-dialog(
      :visible.sync="isError"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
      width="420px")
      div
        img(
          :src="require('@/assets/icons/atencion_dimension.svg')"
          alt="Error"
          class="error__img"
        )
        p.error__msg {{ this.errorMessage }}
      .dialog-footer(slot='footer')
        ods-button(@click='handleClose') {{ this.$t('close') }}
</template>

<script>
import HeaderContent from '@/components/header/HeaderContent'
import NavContent from '@/components/nav/NavContent'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    HeaderContent,
    NavContent
  },

  data () {
    return {
      wrapClass: ''
    }
  },

  computed: {
    ...mapGetters({
      isError: 'isError',
      errorMessage: 'errorMessage',
      isFatal: 'isFatal',
      loadingAxios: 'loadingAxios'
    })
  },

  methods: {
    handleClose () {
      if (this.$route.name !== 'login-form') {
        if (this.isFatal) {
          this.$store.dispatch('logout')
            .then(() => {
              this.$store.commit('SET_ERROR', { error: false })
            })
        } else {
          this.$store.commit('SET_ERROR', { error: false })
        }
      } else {
        this.$store.commit('SET_ERROR', { error: false })
      }
    }
  },

  async mounted () {
    if (this.$route.name !== 'login-form') {
      await this.$store.dispatch('getConfig')
      await this.$store.dispatch('getOptionsMenu')
      if (this.$refs.routeView.getInitialData) {
        await this.$refs.routeView.getInitialData()
      }
      if (this.$refs.routeView.$children[0]) {
        if (this.$refs.routeView.$children[0].$children[0]) {
          if (this.$refs.routeView.$children[0].$children[0].setActiveTab) {
            this.$refs.routeView.$children[0].$children[0].setActiveTab()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
html,
body {
  font-family: "Soho", Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-kerning: none;
  scrollbar-width: none;
  .ods-scrollbar--main-content {
    height: $--main-content-height;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    box-sizing: border-box;
    padding: $--main-content-padding;
    background: $--color-neutral-4;
    &.has-top-bar {
      height: $--main-content-height--topbar;
    }
  }
  .ods-scrollbar__wrap {
    scrollbar-width: none;
  }
}
::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
}
.ods-main {
  background: #F9F9FB;
}

.ods-popover li a {
  display: block;
  width: 100%;
  padding: 12px 8px 8px;
  min-height: 40px;
  box-sizing: border-box;
  font-size: 12px;
  color: initial;
}

.ods-popover li a:hover {
  background: #d5e2eb;
}

.card-menu.ods-actions-menu .ods-actions-menu__scroll-area {
  padding: 8px;
}

.advanced-search-card {
  &.ods-actions-menu {
    width: 338px !important;
  }
  .clear-date {
    color: $--color-danger;
  }
}

.dialog-footer {
  text-align: center;
}

.el-drawer__wrapper {
  z-index:3000!important;
}

.ods-dialog__wrapper {
  z-index:3002!important;
}

.ods-message-box {
  .title {
    font-size: 16px;
    font-weight: 500;
  }

  .text {
    font-size: 14px;
    margin: rem(12) 0;
  }

  .data {
    text-transform: uppercase;
    font-size: 11px;
  }
}

.dialog-footer {
  text-align: center;
}

.error__msg {
  color: #6E767D;
  font-size: rem(16);
  margin-top: rem(40);
}

.error__img {
  width: rem(170);
}

.ods-select-dropdown {
  z-index: 3005!important;
}

.loading-axios {
  cursor: progress;
  * {
    pointer-events: none;
  }
}
.ods-tag--warning {
  background-color: $--color-warning !important;
  border-color: r$--color-warning !important;
  color: $--color-white !important;
}
.ods-actions-menu__button {
  // height: auto !important;
  &--text {
    padding-right: 0 !important;
  }
}
.ods-table {
  .cell {
    // display: flex;
    // align-items: center;
    // word-break: break-word !important;
    &-actions, &-tag {
      padding: 0;
      .cell {
        padding: 0;
        // justify-content: center;
      }
    }
  }
  .ods-tag {
    // min-width: 87px;
    // padding: 0;
    &__content {
      // margin: 0 auto;
    }
  }
  .ods-actions-menu__button {
    // height: 48px !important;
  }
}
.filters-row {
  min-height: rem(48);
  display: flex;
  align-items: center;
}
</style>
